import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 查询开放世界列表
export const queryOpenWorlds: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setOpenWorlds', { ...state.openWorlds, loading: true });
    const { list, pageNum, pageSize, total }: IPageData = await $http.post('/v1/ue/openworld/pagelist', payload);
    commit('setOpenWorlds', { pageNum, pageSize, total, data: list });
  } catch (e) {
    commit('setOpenWorlds', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询开放世界详情
export const queryOpenWorldDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setOpenWorldDetail', { data: null, loading: true });
    const res = await $http.get(`/v1/ue/openworld/${payload}/detail`);
    commit('setOpenWorldDetail', { data: res });
  } catch (e) {
    commit('setOpenWorldDetail', { data: null });
  }
};

// 查询安置点详情
export const queryWorldSlotDetail: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setWorldSlotDetail', { ...state.slotDetail, loading: true });
    const res: any = await $http.post('/v1/ue/openworld/slotdetail', payload);
    commit('setWorldSlotDetail', { data: res });
  } catch (e) {
    commit('setWorldSlotDetail', { data: null });
  }
};

// 查询安置点副本列表
export const queryWorldSlotZones: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setWorldSlotZones', { ...state.zones, loading: true });
    const res = await $http.post('/v1/ue/roominstance/list', {});
    commit('setWorldSlotZones', { data: res });
  } catch (e) {
    commit('setWorldSlotZones', { data: [] });
  }
};

// 查询副本的控制项列表
export const queryZoneTriggers: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setZoneTriggers', { ...state.triggers, loading: true });
    const res = await $http.post('/v1/data/ue/openworld/slotlist', payload);
    commit('setZoneTriggers', { data: res || [] });
  } catch (e) {
    commit('setZoneTriggers', { data: [] });
  }
};

// 新增开放世界
export const addOpenWorld: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/ue/openworld/add', payload);
    store.commit('common/setToast', { visible: true, text: '新增成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 编辑开放世界
export const editOpenWorld: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/ue/openworld/modify', payload);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除开放世界
export const deleteOpenWorld: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/ue/openworld/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 更新安置点
export const updateWorldSlot: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    const res = await $http.post('/v1/ue/openworld/updateworldslot', payload);
    commit('setWorldSlotDetail', { data: res });
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 更新安置点上的控制项
export const updateWorldSlotTrigger: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    const res: any = await $http.post('/v1/ue/openworld/updateslots', payload);
    commit('setWorldSlotDetail', { data: res });
    commit('setZoneTriggers', { data: res?.worldSlotConfigs || [] });
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } finally {
    commit('setLoading', false);
  }
};
